import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import LayerPopup from 'components/common/LayerPopup'
import * as itemsActions from 'store/modules/items';

class LayerPopupContainer extends Component {

  componentDidMount = () => {
    const {ItemsActions, itemLayerPopInfo} = this.props;
    const {lstItemList, openYn} = itemLayerPopInfo;
    // console.log('lstItemList : ' + JSON.stringify(lstItemList));
    if(lstItemList.length == 0) ItemsActions.setLocalHist({lstItemList});
    if(openYn == 'N') ItemsActions.setLayerOpenYn('Y');
  }

  popupClose = () => {
    const {ItemsActions} = this.props;
    ItemsActions.setLayerOpenYn('N');
  }

  render() {
    const {popupClose} = this;
    const {itemLayerPopInfo} = this.props;

    return (
      <LayerPopup 
      itemLayerPopInfo={itemLayerPopInfo} 
      popupClose={popupClose}
      // goSimul={goSimul}
      // itemKind={itemKind}
      />
    );
  }
}

export default connect(
  (state) => ({
    itemLayerPopInfo: state.items.toJS().itemLayerPopInfo,
    // itemKind: state.items.toJS().itemFilters.itemKind
  }),
  (dispatch) => ({
    ItemsActions: bindActionCreators(itemsActions, dispatch)
  })
)(LayerPopupContainer);